import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function confirmPasswordValidator(passwordControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent || !(control.parent instanceof FormGroup)) {
      return null;
    }

    const passwordControl = control.parent.get(passwordControlName);

    if (passwordControl && control.value !== passwordControl.value) {
      return { passwordMismatch: true };
    }

    return null;
  };
}
